import { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import style from './preview.module.scss';
// import ModalClosePreviewIcon from '@/assets/icons/modal-close-preview.svg?react';
// import Modal from '@/common/components/basic/modal';

export interface IPreviewContentProps {
  content: string[] | string;
  onCancel: () => void;
}
const PreviewContent = (props: IPreviewContentProps) => {
  const { content } = props;
  const [resContent, setResContent] = useState<string[]>([]);
  const pcFrameRef = useRef<HTMLIFrameElement>(null);
  const mobileFrameRef = useRef<HTMLIFrameElement>(null);
  // const hasContent = useMemo(() => {
  //   return resContent && resContent.length > 0 && (resContent[0] || resContent[1]);
  // }, [resContent]);
  useEffect(() => {
    if (typeof content === 'string') {
      setResContent([content, content]);
    } else {
      setResContent(content);
    }
  }, [content]);
  const loadIframe = () => {
    try {
      if (!(pcFrameRef.current?.contentDocument && mobileFrameRef.current?.contentDocument)) {
        return;
      }
      const pcLinks = pcFrameRef.current.contentDocument.body.querySelectorAll('a') || [];
      const mobileLinks = mobileFrameRef.current.contentDocument.body.querySelectorAll('a') || [];
      for (let i = 0; i < pcLinks.length; i++) {
        pcLinks[i].style.cursor = 'default';
        pcLinks[i].href = '';
        pcLinks[i].onclick = function () {
          return false;
        };
      }
      for (let i = 0; i < mobileLinks.length; i++) {
        mobileLinks[i].style.cursor = 'default';
        mobileLinks[i].href = '';
        mobileLinks[i].onclick = function () {
          return false;
        };
      }
    } catch (e) {
      console.error('[error loadIframe preview]', e);
    }
  };
  // if (!hasContent) {
  //   return null;
  // }
  return (
    <div className={classnames(style.preview)}>
      {/* Modal component is not available - commenting out for now */}
      {/* <Modal
        title="Preview"
        visible={!!hasContent}
        open={!!hasContent}
        footer={null}
        onCancel={onCancel}
        centered
        wrapClassName={style.modalWrap}
        closeIcon={<ModalClosePreviewIcon />}
        // bodyStyle={{ paddingTop: '0px' }}
        width={916}
      > */}
        <div className={classnames(style.previewContainer)}>
          <div className={style.scroller}>
            <div className={style.previewWrap}>
              <div className={style.previewPc}>
                <iframe
                  ref={pcFrameRef}
                  title="Preview"
                  sandbox="allow-scripts allow-same-origin allow-downloads"
                  data-alloy-tabstop="true"
                  tabIndex={-1}
                  srcDoc={resContent[0]}
                  onLoad={loadIframe}
                />
              </div>
              <div className={style.previewMobile}>
                <iframe
                  ref={mobileFrameRef}
                  title="Preview"
                  sandbox="allow-scripts allow-same-origin allow-downloads"
                  data-alloy-tabstop="true"
                  tabIndex={-1}
                  srcDoc={resContent[1]}
                  onLoad={loadIframe}
                />
              </div>
            </div>
          </div>
        </div>
      {/* </Modal> */}
    </div>
  );
};

export default PreviewContent;
